import commentResponseSchema from './commentResponseSchema'

export default {
	type: 'object',
	properties: {
		items: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					$ref: commentResponseSchema,
				},
			},
		},
		lastKey: {
			type: 'string',
		},
	},
	required: ['items'],
	additionalProperties: false,
}
